import {
  ColumnHeightOutlined,
  DownOutlined,
  FundOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import { useContext } from 'react';
import { useStore } from 'zustand';

import { LegacyHotelContext } from 'app/context/HotelContext/LegacyHotelContext';

import { inventoryStore } from '../../../InventoryStore';
import { DEFAULT_COLLAPSE_OVERVIEW_KEY } from '../../../type';

export const SettingsDropdown = () => {
  const { hasAtLeastOneDayPackage } = useContext(LegacyHotelContext);

  const activeCollapseKey = useStore(
    inventoryStore,
    (state) => state.activeCollapseKey
  );
  const setActiveCollapseKey = useStore(
    inventoryStore,
    (state) => state.setActiveCollapseKey
  );
  const inventory = useStore(inventoryStore, (state) => state.inventory);
  const setOpenEditMaxBooking = useStore(
    inventoryStore,
    (state) => state.setOpenEditMaxBooking
  );

  const roomIds = inventory?.rooms
    ? Object.values(inventory.rooms).map((room) => room.roomId.toString())
    : [];
  const isExpanded = activeCollapseKey.length === roomIds.length + 1;

  const onCollapseAll = () => {
    setActiveCollapseKey([]);
  };

  const onExpandsAll = () => {
    setActiveCollapseKey([...roomIds, DEFAULT_COLLAPSE_OVERVIEW_KEY]);
  };

  const dropdownItems = [
    ...(!hasAtLeastOneDayPackage
      ? [
          {
            label: 'Set max booking',
            key: 'set-max-booking',
            icon: <FundOutlined />,
            onClick: () => setOpenEditMaxBooking(true),
          },
        ]
      : []),
    ...(!hasAtLeastOneDayPackage || roomIds.length > 1
      ? [
          {
            label: !isExpanded ? 'Expand all' : 'Collapse all',
            key: 'expand-collapse-all',
            icon: <ColumnHeightOutlined />,
            onClick: () => {
              !isExpanded ? onExpandsAll() : onCollapseAll();
            },
          },
        ]
      : []),
  ];

  if (!dropdownItems.length) {
    return null;
  }

  return (
    <Dropdown menu={{ items: dropdownItems }} trigger={['click']}>
      <Button>
        <SettingOutlined />
        <DownOutlined />
      </Button>
    </Dropdown>
  );
};
